import { IApplicationContext } from '../../types/applicationContext';
import {
  fetchPublicMyHomeV1HowToEarn,
  IPublicMyHomeV1HowToEarnResponse200 as IRes200,
  IPublicMyHomeV1HowToEarnResponse400 as IRes400,
} from '../../repositories/price-estimator/my-home/v1/how-to-earn';
import { BadRequestError } from '@cian/valuation-utils-component';
import { IHowToEarnSchema } from '../../repositories/price-estimator/entities/how_to_earn/HowToEarnSchema';

export const getMyHomeProfit = async (
  context: IApplicationContext,
  myHomeId: number,
): Promise<IHowToEarnSchema | null> => {
  const { httpApi, logger } = context;

  try {
    const res = await fetchPublicMyHomeV1HowToEarn<IRes200, IRes400>({
      httpApi,
      parameters: {
        myHomeId,
      },
    });

    if (res.statusCode !== 200) {
      throw new BadRequestError({
        message: res.response.message as string,
        domain: 'getMyHomeProfit.ts',
        details: {
          errors: JSON.stringify(res.response.errors),
        },
      });
    }

    return res.response.howToEarn;
  } catch (e) {
    if (!(e instanceof BadRequestError)) {
      logger.error('Ошибка загрузки информации по объекту МД ', {
        message: e.message,
        domain: 'getMyHomeProfit.ts',
        details: e,
      });
    } else {
      logger.debug('Ошибка загрузки информации по объекту МД ', {
        message: e.message,
        domain: e.domain,
        details: e,
      });
    }

    return null;
  }
};
